import axios from "axios";
import { toast } from "react-toastify";

export const setAxiosAuthToken = token => {
  // console.log(token);
  if (typeof token !== "undefined" && token) {
    // Apply for every request
    axios.defaults.headers.common["Authorization"] = "Token " + token;
  } else {
    // Delete auth header
    delete axios.defaults.headers.common["Authorization"];
  }
};

export const toastOnError = error => {
  if (error.response) {
    // known error
    toast.error(JSON.stringify(error.response.data));
  } else if (error.message) {
    toast.error(JSON.stringify(error.message));
  } else {
    toast.error(JSON.stringify(error));
  }
};

export const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

export const dataUrlToFile = (url, fileName) => {
  const [mediaType, data] = url.split(",");
  const mime = mediaType.match(/:(.*?);/)?.[0];
  var n = data.length;
  const arr = new Uint8Array(n);
  while (n--) {
    arr[n] = data.charCodeAt(n);
  }
  return new File([arr], fileName, { type: mime });
};